import { useEffect } from 'react';
import { setContractCurrencyValidation } from 'smartforms/utils/contractCurrencyValidationFlag';
import { setEngagementContractDateValidation } from 'smartforms/utils/engagementContractDateValidationFlag';
import { setValidateContractContractingParty } from 'smartforms/utils/validateContractContractingPartyFlag';
import { useFeatureFlags } from 'src/components/common/featureFlag/useFeatureFlags';

export const SmartFormFlagsSync: React.FC = () => {
  const { isEnabledSecondLevelSubFeature } = useFeatureFlags();

  const isContractFeatureEnabled = (subFeature: string) =>
    isEnabledSecondLevelSubFeature?.('sourcing', 'contract', subFeature) ?? false;

  const isContractDateValidationEnabled = isContractFeatureEnabled('date-validation');
  const isSupplierValidationEnabled = isContractFeatureEnabled('supplier-validation');
  const isCurrencyValidationEnabled = isContractFeatureEnabled('currency');

  useEffect(() => {
    setEngagementContractDateValidation(isContractDateValidationEnabled);
    setValidateContractContractingParty(isSupplierValidationEnabled);
    setContractCurrencyValidation(isCurrencyValidationEnabled);
  }, [isContractDateValidationEnabled, isSupplierValidationEnabled, isCurrencyValidationEnabled]);

  return null;
};
